import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IPartenaireState {
  partenaires: IPartenaire[];
  filteredPartenaires: IPartenaire[];
}

export interface IPartenaire {
  idPartenaire: number;
  libelle: string;
  logoPartenaire: string;

}




const initialState: IPartenaireState = {
  partenaires: [],
  filteredPartenaires: []
}

export const partenaireSlice: any = createSlice({
  name: "partenaireSlice",
  initialState: initialState,
  reducers: {

    addPartenaire: (state, action: PayloadAction<IPartenaire>) => {
      state.partenaires.unshift(action.payload);
      state.filteredPartenaires.unshift(action.payload);
    },

    setPartenaires: (state, action: PayloadAction<IPartenaire[]>) => {
      state.partenaires = action.payload;
    },
    setFilteredPartenaires: (state, action: PayloadAction<IPartenaire[]>) => {
      state.filteredPartenaires = action.payload;
    },

    updatePartenaire: (state, action: PayloadAction<IPartenaire>) => {
      const newPartenaires = state.partenaires.map((i: IPartenaire) =>
        i.idPartenaire === action.payload.idPartenaire
          ? action.payload
          : i
      );
      const newFilteredPartenaires = state.filteredPartenaires.map(
        (i: IPartenaire) =>
          i.idPartenaire === action.payload.idPartenaire
            ? action.payload
            : i
      );
      state.partenaires = newPartenaires;
      state.filteredPartenaires = newFilteredPartenaires;
    },


    deletePartenaire: (state, action: PayloadAction<{ idPartenaire: number }>) => {
      state.partenaires = state.partenaires.filter((partenaire: IPartenaire) => partenaire.idPartenaire !== action.payload.idPartenaire);
      state.filteredPartenaires = state.filteredPartenaires.filter((partenaire: IPartenaire) => partenaire.idPartenaire !== action.payload.idPartenaire);
    },
  },
});

export const {
  addPartenaire,
  deletePartenaire,
  setPartenaires,
  setFilteredPartenaires,
  updatePartenaire,
} = partenaireSlice.actions;

export default partenaireSlice.reducer;
